import React from 'react';
import { useTranslation } from 'react-i18next';
import './NotFound.css';
import Button from '../../components/UI/Button/Button';

const NotFound = () => {
    const { t, i18n } = useTranslation();

    return (
        <section className='section'>
            <div className="not-found-container">
            <div className="not-found-content">
                <div className="not-found-icon">
                    <span className="error-code">404</span>
                </div>
                <h1 className="not-found-title">{t('notFound.title', 'Page Not Found')}</h1>
                <p className="not-found-message">
                    {t('notFound.message', 'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.')}
                </p>
                <div className="not-found-actions">
                    <Button to={`/${i18n.language}`} className="not-found-home-btn">
                        {t('notFound.goHome', 'Go to Home')}
                    </Button>
                    <Button to={`/${i18n.language}/contact`} variant="outline" className="not-found-contact-btn">
                        {t('notFound.contactUs', 'Contact Us')}
                    </Button>
                </div>
            </div>
        </div>
        </section>
    );
};

export default NotFound;